import { useNavigate } from "react-router-dom";

const LOGO_URL = "/img/logo.jpg";

const BUILDING_URL = "/img/school.jpg";

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div
      data-testid="landing-page"
      className="relative w-full min-h-screen flex flex-col bg-white overflow-hidden"
    >
      {/* Top dark-blue branded header */}
      <header
        data-testid="landing-header"
        className="w-full eis-header text-white"
      >
        <div className="max-w-7xl mx-auto px-3 md:px-6 py-3 md:py-4 flex items-center gap-3 md:gap-4">
          <img
            src={LOGO_URL}
            alt="EIS Logo"
            className="h-16 w-16 md:h-20 md:w-20 rounded-lg object-cover flex-shrink-0 shadow"
          />
          <div className="flex-1 min-w-0">
            <h1 className="text-xl md:text-3xl lg:text-4xl font-extrabold tracking-tight leading-tight">
              EUREKA INTERNATIONAL SCHOOL
            </h1>
            <div className="text-[11px] md:text-sm font-semibold mt-1 leading-tight text-white/95">
              <p>Shree Control Chowk Rd, Dhayari, Pune, Maharashtra 411041</p>
              <p>+91 7276600034 / +91 9022955376</p>
              <p className="truncate">schooleurekainternational@gmail.com</p>
            </div>
          </div>
          <div className="hidden md:block text-right flex-shrink-0">
            <p className="text-sm md:text-base font-semibold">
              CBSE Affiliation No. 1131508
            </p>
          </div>
        </div>
      </header>

      {/* Building photo section with buttons */}
      <div className="relative flex-1 w-full bg-slate-100">
        <img
          src={BUILDING_URL}
          alt="Eureka International School Building"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-black/45 to-transparent pointer-events-none" />

        <div className="absolute bottom-6 md:bottom-10 right-6 md:right-10 flex gap-4 z-10">
          <button
            data-testid="landing-login-btn"
            onClick={() => navigate("/auth?mode=login")}
            className="rounded-full px-8 md:px-10 py-4 md:py-5 text-white font-bold text-base md:text-lg shadow-lg hover:brightness-110 active:scale-[0.98] transition"
            style={{ backgroundColor: "#0b1f7a" }}
          >
            LOG IN
          </button>
          <button
            data-testid="landing-signup-btn"
            onClick={() => navigate("/auth?mode=signup")}
            className="rounded-full px-8 md:px-10 py-4 md:py-5 text-white font-bold text-base md:text-lg shadow-lg hover:brightness-110 active:scale-[0.98] transition"
            style={{ backgroundColor: "#0b1f7a" }}
          >
            SIGN UP
          </button>
        </div>
      </div>
    </div>
  );
}
